import {
  Grid,
  Typography,
  useMediaQuery,
  useTheme,
  Stack,
  Paper,
} from '@mui/material';
import { Category } from '../../types/types';
import { Link } from 'react-router';
import { ReactSVG } from 'react-svg';
import { getIconByTheme } from '../../utilities/ArticleCoverImageUtilities';

interface CategoryGridProps {
  readonly categories?: Category[];
}

export default function CategoryGrid({ categories = [] }: CategoryGridProps) {
  const theme = useTheme();
  const isMobileScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Grid container columnSpacing={3} rowSpacing={{ xs: 1, sm: 1.5 }}>
      {categories.map((category) => {
        return (
          <Grid
            size={{ xs: 12, sm: 6, md: 4 }}
            key={'category-grid-' + category.name}
            component={Link}
            data-testid={'category-grid-item-link-' + category.name}
            to={category.path}
            sx={{ textDecoration: 'none' }}
          >
            <Paper
              variant='outlined'
              sx={{ backgroundColor: 'white', padding: 2 }}
            >
              <Stack
                direction='row'
                useFlexGap
                sx={{
                  justifyContent: 'start',
                  alignItems: 'center',
                  gap: 2,
                }}
              >
                <ReactSVG
                  src={'/themecover/' + getIconByTheme(category.name)}
                  beforeInjection={(svg) => {
                    svg.classList.add('svg-icon');
                    svg.setAttribute('style', 'height: 48px');
                  }}
                />

                <Typography
                  component='h3'
                  variant={isMobileScreen ? 'h3' : 'h5'}
                  sx={{
                    color: 'text.primary',
                    ':hover': { textDecoration: 'underline' },
                  }}
                >
                  {category.name}
                </Typography>
              </Stack>
            </Paper>
          </Grid>
        );
      })}
    </Grid>
  );
}
